// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
export const OwnerType = {
    OWNER_TYPE_UNSPECIFIED: 'OWNER_TYPE_UNSPECIFIED',
    OWNER_TYPE_PARTNER: 'OWNER_TYPE_PARTNER',
    OWNER_TYPE_ACCOUNT_GROUP: 'OWNER_TYPE_ACCOUNT_GROUP',
};
export const OwnerTypeValue = {
    OWNER_TYPE_UNSPECIFIED: 0,
    OWNER_TYPE_PARTNER: 1,
    OWNER_TYPE_ACCOUNT_GROUP: 2,
};
export const ValidationStatus = {
    VALIDATION_STATUS_UNSPECIFIED: 'VALIDATION_STATUS_UNSPECIFIED',
    VALIDATION_STATUS_COMPLIANT: 'VALIDATION_STATUS_COMPLIANT',
    VALIDATION_STATUS_NON_COMPLIANT: 'VALIDATION_STATUS_NON_COMPLIANT',
};
export const ValidationStatusValue = {
    VALIDATION_STATUS_UNSPECIFIED: 0,
    VALIDATION_STATUS_COMPLIANT: 1,
    VALIDATION_STATUS_NON_COMPLIANT: 2,
};
export const DataField = {
    DATA_FIELD_UNSPECIFIED: 'DATA_FIELD_UNSPECIFIED',
    DATA_FIELD_LEGAL_BUSINESS_NAME: 'DATA_FIELD_LEGAL_BUSINESS_NAME',
    DATA_FIELD_BUSINESS_CATEGORY: 'DATA_FIELD_BUSINESS_CATEGORY',
    DATA_FIELD_BUSINESS_TYPE: 'DATA_FIELD_BUSINESS_TYPE',
    DATA_FIELD_REGION_OF_OPERATION: 'DATA_FIELD_REGION_OF_OPERATION',
    DATA_FIELD_REGISTRATION_IDENTIFIER: 'DATA_FIELD_REGISTRATION_IDENTIFIER',
    DATA_FIELD_STREET_ADDRESS: 'DATA_FIELD_STREET_ADDRESS',
    DATA_FIELD_STREET_ADDRESS_SECONDARY: 'DATA_FIELD_STREET_ADDRESS_SECONDARY',
    DATA_FIELD_CITY: 'DATA_FIELD_CITY',
    DATA_FIELD_STATE: 'DATA_FIELD_STATE',
    DATA_FIELD_POSTAL_CODE: 'DATA_FIELD_POSTAL_CODE',
    DATA_FIELD_WEBSITE_URL: 'DATA_FIELD_WEBSITE_URL',
    DATA_FIELD_COUNTRY: 'DATA_FIELD_COUNTRY',
    DATA_FIELD_FIRST_NAME: 'DATA_FIELD_FIRST_NAME',
    DATA_FIELD_LAST_NAME: 'DATA_FIELD_LAST_NAME',
    DATA_FIELD_JOB_POSITION: 'DATA_FIELD_JOB_POSITION',
    DATA_FIELD_BUSINESS_TITLE: 'DATA_FIELD_BUSINESS_TITLE',
    DATA_FIELD_EMAIL: 'DATA_FIELD_EMAIL',
    DATA_FIELD_PHONE_NUMBER: 'DATA_FIELD_PHONE_NUMBER',
    DATA_FIELD_BUSINESS_REGISTRATION_NUMBER: 'DATA_FIELD_BUSINESS_REGISTRATION_NUMBER',
};
export const DataFieldValue = {
    DATA_FIELD_UNSPECIFIED: 0,
    DATA_FIELD_LEGAL_BUSINESS_NAME: 1,
    DATA_FIELD_BUSINESS_CATEGORY: 2,
    DATA_FIELD_BUSINESS_TYPE: 3,
    DATA_FIELD_REGION_OF_OPERATION: 4,
    DATA_FIELD_REGISTRATION_IDENTIFIER: 5,
    DATA_FIELD_STREET_ADDRESS: 6,
    DATA_FIELD_STREET_ADDRESS_SECONDARY: 7,
    DATA_FIELD_CITY: 8,
    DATA_FIELD_STATE: 9,
    DATA_FIELD_POSTAL_CODE: 10,
    DATA_FIELD_WEBSITE_URL: 11,
    DATA_FIELD_COUNTRY: 12,
    DATA_FIELD_FIRST_NAME: 13,
    DATA_FIELD_LAST_NAME: 14,
    DATA_FIELD_JOB_POSITION: 15,
    DATA_FIELD_BUSINESS_TITLE: 16,
    DATA_FIELD_EMAIL: 17,
    DATA_FIELD_PHONE_NUMBER: 18,
    DATA_FIELD_BUSINESS_REGISTRATION_NUMBER: 19,
};
export const BrandStatus = {
    BRAND_STATUS_UNSPECIFIED: 'BRAND_STATUS_UNSPECIFIED',
    BRAND_STATUS_PENDING: 'BRAND_STATUS_PENDING',
    BRAND_STATUS_IN_REVIEW: 'BRAND_STATUS_IN_REVIEW',
    BRAND_STATUS_FAILED: 'BRAND_STATUS_FAILED',
    BRAND_STATUS_APPROVED: 'BRAND_STATUS_APPROVED',
};
export const BrandStatusValue = {
    BRAND_STATUS_UNSPECIFIED: 0,
    BRAND_STATUS_PENDING: 1,
    BRAND_STATUS_IN_REVIEW: 2,
    BRAND_STATUS_FAILED: 3,
    BRAND_STATUS_APPROVED: 4,
};
export const MessagingCampaignStatus = {
    MESSAGING_CAMPAIGN_STATUS_UNSPECIFIED: 'MESSAGING_CAMPAIGN_STATUS_UNSPECIFIED',
    MESSAGING_CAMPAIGN_STATUS_PENDING: 'MESSAGING_CAMPAIGN_STATUS_PENDING',
    MESSAGING_CAMPAIGN_STATUS_FAILED: 'MESSAGING_CAMPAIGN_STATUS_FAILED',
    MESSAGING_CAMPAIGN_STATUS_VERIFIED: 'MESSAGING_CAMPAIGN_STATUS_VERIFIED',
};
export const MessagingCampaignStatusValue = {
    MESSAGING_CAMPAIGN_STATUS_UNSPECIFIED: 0,
    MESSAGING_CAMPAIGN_STATUS_PENDING: 1,
    MESSAGING_CAMPAIGN_STATUS_FAILED: 2,
    MESSAGING_CAMPAIGN_STATUS_VERIFIED: 3,
};
export const ParticipantType = {
    PARTICIPANT_TYPE_UNKNOWN: 'PARTICIPANT_TYPE_UNKNOWN',
    PARTICIPANT_TYPE_ACCOUNT_GROUP: 'PARTICIPANT_TYPE_ACCOUNT_GROUP',
    PARTICIPANT_TYPE_CUSTOMER: 'PARTICIPANT_TYPE_CUSTOMER',
    PARTICIPANT_TYPE_PARTNER: 'PARTICIPANT_TYPE_PARTNER',
};
export const ParticipantTypeValue = {
    PARTICIPANT_TYPE_UNKNOWN: 0,
    PARTICIPANT_TYPE_ACCOUNT_GROUP: 1,
    PARTICIPANT_TYPE_CUSTOMER: 2,
    PARTICIPANT_TYPE_PARTNER: 3,
};
export const RegulationStatus = {
    REGULATION_STATUS_UNSPECIFIED: 'REGULATION_STATUS_UNSPECIFIED',
    REGULATION_STATUS_APPROVED: 'REGULATION_STATUS_APPROVED',
    REGULATION_STATUS_PENDING_REVIEW: 'REGULATION_STATUS_PENDING_REVIEW',
    REGULATION_STATUS_REJECTED: 'REGULATION_STATUS_REJECTED',
};
export const RegulationStatusValue = {
    REGULATION_STATUS_UNSPECIFIED: 0,
    REGULATION_STATUS_APPROVED: 1,
    REGULATION_STATUS_PENDING_REVIEW: 2,
    REGULATION_STATUS_REJECTED: 3,
};
export const StatusType = {
    STATUS_TYPE_UNSPECIFIED: 'STATUS_TYPE_UNSPECIFIED',
    STATUS_TYPE_QUEUED: 'STATUS_TYPE_QUEUED',
    STATUS_TYPE_SENDING: 'STATUS_TYPE_SENDING',
    STATUS_TYPE_SENT: 'STATUS_TYPE_SENT',
    STATUS_TYPE_FAILED: 'STATUS_TYPE_FAILED',
    STATUS_TYPE_DELIVERED: 'STATUS_TYPE_DELIVERED',
    STATUS_TYPE_UNDELIVERED: 'STATUS_TYPE_UNDELIVERED',
    STATUS_TYPE_RECEIVING: 'STATUS_TYPE_RECEIVING',
    STATUS_TYPE_RECEIVED: 'STATUS_TYPE_RECEIVED',
    STATUS_TYPE_ACCEPTED: 'STATUS_TYPE_ACCEPTED',
    STATUS_TYPE_SCHEDULED: 'STATUS_TYPE_SCHEDULED',
    STATUS_TYPE_CANCELED: 'STATUS_TYPE_CANCELED',
    STATUS_TYPE_CLICKED: 'STATUS_TYPE_CLICKED',
};
export const StatusTypeValue = {
    STATUS_TYPE_UNSPECIFIED: 0,
    STATUS_TYPE_QUEUED: 1,
    STATUS_TYPE_SENDING: 2,
    STATUS_TYPE_SENT: 3,
    STATUS_TYPE_FAILED: 4,
    STATUS_TYPE_DELIVERED: 5,
    STATUS_TYPE_UNDELIVERED: 6,
    STATUS_TYPE_RECEIVING: 7,
    STATUS_TYPE_RECEIVED: 8,
    STATUS_TYPE_ACCEPTED: 9,
    STATUS_TYPE_SCHEDULED: 10,
    STATUS_TYPE_CANCELED: 11,
    STATUS_TYPE_CLICKED: 12,
};
export const MissedCallTrigger = {
    MISSED_CALL_TRIGGER_UNSPECIFIED: 'MISSED_CALL_TRIGGER_UNSPECIFIED',
    MISSED_CALL_TRIGGER_CALL_RECEIVED: 'MISSED_CALL_TRIGGER_CALL_RECEIVED',
    MISSED_CALL_TRIGGER_FORWARDED_CALL_MISSED: 'MISSED_CALL_TRIGGER_FORWARDED_CALL_MISSED',
};
export const MissedCallTriggerValue = {
    MISSED_CALL_TRIGGER_UNSPECIFIED: 0,
    MISSED_CALL_TRIGGER_CALL_RECEIVED: 1,
    MISSED_CALL_TRIGGER_FORWARDED_CALL_MISSED: 2,
};
export const StartCallMode = {
    START_CALL_UNSPECIFIED: 'START_CALL_UNSPECIFIED',
    START_CALL_PLAY_TTS_MESSAGE: 'START_CALL_PLAY_TTS_MESSAGE',
    START_CALL_DO_NOTHING: 'START_CALL_DO_NOTHING',
};
export const StartCallModeValue = {
    START_CALL_UNSPECIFIED: 0,
    START_CALL_PLAY_TTS_MESSAGE: 1,
    START_CALL_DO_NOTHING: 2,
};
export const PurchaseRequestState = {
    PURCHASE_REQUEST_STATE_UNSPECIFIED: 'PURCHASE_REQUEST_STATE_UNSPECIFIED',
    PURCHASE_REQUEST_STATE_NOT_STARTED: 'PURCHASE_REQUEST_STATE_NOT_STARTED',
    PURCHASE_REQUEST_STATE_REQUESTED: 'PURCHASE_REQUEST_STATE_REQUESTED',
    PURCHASE_REQUEST_STATE_PROVISIONED: 'PURCHASE_REQUEST_STATE_PROVISIONED',
    PURCHASE_REQUEST_STATE_FAILED: 'PURCHASE_REQUEST_STATE_FAILED',
};
export const PurchaseRequestStateValue = {
    PURCHASE_REQUEST_STATE_UNSPECIFIED: 0,
    PURCHASE_REQUEST_STATE_NOT_STARTED: 1,
    PURCHASE_REQUEST_STATE_REQUESTED: 2,
    PURCHASE_REQUEST_STATE_PROVISIONED: 3,
    PURCHASE_REQUEST_STATE_FAILED: 4,
};
export const PurchaseChannel = {
    PURCHASE_CHANNEL_UNSPECIFIED: 'PURCHASE_CHANNEL_UNSPECIFIED',
    PURCHASE_CHANNEL_WEB_FORM: 'PURCHASE_CHANNEL_WEB_FORM',
    PURCHASE_CHANNEL_EMAIL: 'PURCHASE_CHANNEL_EMAIL',
    PURCHASE_CHANNEL_API: 'PURCHASE_CHANNEL_API',
    PURCHASE_CHANNEL_MANUAL: 'PURCHASE_CHANNEL_MANUAL',
};
export const PurchaseChannelValue = {
    PURCHASE_CHANNEL_UNSPECIFIED: 0,
    PURCHASE_CHANNEL_WEB_FORM: 1,
    PURCHASE_CHANNEL_EMAIL: 2,
    PURCHASE_CHANNEL_API: 3,
    PURCHASE_CHANNEL_MANUAL: 4,
};
export const NotificationState = {
    NOTIFICATION_STATE_UNSPECIFIED: 'NOTIFICATION_STATE_UNSPECIFIED',
    NOTIFICATION_STATE_NOT_REQUIRED: 'NOTIFICATION_STATE_NOT_REQUIRED',
    NOTIFICATION_STATE_PENDING: 'NOTIFICATION_STATE_PENDING',
    NOTIFICATION_STATE_SENT: 'NOTIFICATION_STATE_SENT',
    NOTIFICATION_STATE_FAILED: 'NOTIFICATION_STATE_FAILED',
};
export const NotificationStateValue = {
    NOTIFICATION_STATE_UNSPECIFIED: 0,
    NOTIFICATION_STATE_NOT_REQUIRED: 1,
    NOTIFICATION_STATE_PENDING: 2,
    NOTIFICATION_STATE_SENT: 3,
    NOTIFICATION_STATE_FAILED: 4,
};
export const Source = {
    SOURCE_UNSPECIFIED: 'SOURCE_UNSPECIFIED',
    SOURCE_ORCHESTRATOR: 'SOURCE_ORCHESTRATOR',
    SOURCE_DISCOVERED_EXTERNALLY: 'SOURCE_DISCOVERED_EXTERNALLY',
    SOURCE_MANUAL: 'SOURCE_MANUAL',
};
export const SourceValue = {
    SOURCE_UNSPECIFIED: 0,
    SOURCE_ORCHESTRATOR: 1,
    SOURCE_DISCOVERED_EXTERNALLY: 2,
    SOURCE_MANUAL: 3,
};
export const LifecycleState = {
    LIFECYCLE_STATE_UNSPECIFIED: 'LIFECYCLE_STATE_UNSPECIFIED',
    LIFECYCLE_STATE_ACTIVE: 'LIFECYCLE_STATE_ACTIVE',
    LIFECYCLE_STATE_RELEASED: 'LIFECYCLE_STATE_RELEASED',
    LIFECYCLE_STATE_REPLACED: 'LIFECYCLE_STATE_REPLACED',
};
export const LifecycleStateValue = {
    LIFECYCLE_STATE_UNSPECIFIED: 0,
    LIFECYCLE_STATE_ACTIVE: 1,
    LIFECYCLE_STATE_RELEASED: 2,
    LIFECYCLE_STATE_REPLACED: 3,
};
export const LimitType = {
    LIMIT_TYPE_UNSPECIFIED: 'LIMIT_TYPE_UNSPECIFIED',
    LIMIT_TYPE_DAILY: 'LIMIT_TYPE_DAILY',
};
export const LimitTypeValue = {
    LIMIT_TYPE_UNSPECIFIED: 0,
    LIMIT_TYPE_DAILY: 1,
};
export const CanSendReason = {
    CAN_SEND_REASON_UNSPECIFIED: 'CAN_SEND_REASON_UNSPECIFIED',
    CAN_SEND_REASON_MISSING_PHONE_NUMBER: 'CAN_SEND_REASON_MISSING_PHONE_NUMBER',
    CAN_SEND_REASON_MISSING_SUBACCOUNT: 'CAN_SEND_REASON_MISSING_SUBACCOUNT',
    CAN_SEND_REASON_A2P_REGISTRATION_REQUIRED: 'CAN_SEND_REASON_A2P_REGISTRATION_REQUIRED',
    CAN_SEND_REASON_A2P_REGISTRATION_IN_PROGRESS: 'CAN_SEND_REASON_A2P_REGISTRATION_IN_PROGRESS',
    CAN_SEND_REASON_A2P_REGISTRATION_REJECTED: 'CAN_SEND_REASON_A2P_REGISTRATION_REJECTED',
    CAN_SEND_REASON_UNSUPPORTED_COUNTRY: 'CAN_SEND_REASON_UNSUPPORTED_COUNTRY',
    CAN_SEND_REASON_UNSUPPORTED_SENDER: 'CAN_SEND_REASON_UNSUPPORTED_SENDER',
    CAN_SEND_REASON_REGULATION_REQUIRED: 'CAN_SEND_REASON_REGULATION_REQUIRED',
    CAN_SEND_REASON_REGULATION_IN_PROGRESS: 'CAN_SEND_REASON_REGULATION_IN_PROGRESS',
    CAN_SEND_REASON_REGULATION_REJECTED: 'CAN_SEND_REASON_REGULATION_REJECTED',
};
export const CanSendReasonValue = {
    CAN_SEND_REASON_UNSPECIFIED: 0,
    CAN_SEND_REASON_MISSING_PHONE_NUMBER: 1,
    CAN_SEND_REASON_MISSING_SUBACCOUNT: 2,
    CAN_SEND_REASON_A2P_REGISTRATION_REQUIRED: 3,
    CAN_SEND_REASON_A2P_REGISTRATION_IN_PROGRESS: 4,
    CAN_SEND_REASON_A2P_REGISTRATION_REJECTED: 5,
    CAN_SEND_REASON_UNSUPPORTED_COUNTRY: 6,
    CAN_SEND_REASON_UNSUPPORTED_SENDER: 7,
    CAN_SEND_REASON_REGULATION_REQUIRED: 8,
    CAN_SEND_REASON_REGULATION_IN_PROGRESS: 9,
    CAN_SEND_REASON_REGULATION_REJECTED: 10,
};
export const ConsentType = {
    CONSENT_TYPE_UNSPECIFIED: 'CONSENT_TYPE_UNSPECIFIED',
    CONSENT_TYPE_SMS_MARKETING: 'CONSENT_TYPE_SMS_MARKETING',
};
export const ConsentTypeValue = {
    CONSENT_TYPE_UNSPECIFIED: 0,
    CONSENT_TYPE_SMS_MARKETING: 1,
};
export const ConsentStatus = {
    CONSENT_STATUS_UNSPECIFIED: 'CONSENT_STATUS_UNSPECIFIED',
    CONSENT_STATUS_SUBSCRIBED: 'CONSENT_STATUS_SUBSCRIBED',
    CONSENT_STATUS_UNSUBSCRIBED: 'CONSENT_STATUS_UNSUBSCRIBED',
    CONSENT_STATUS_UNSET: 'CONSENT_STATUS_UNSET',
};
export const ConsentStatusValue = {
    CONSENT_STATUS_UNSPECIFIED: 0,
    CONSENT_STATUS_SUBSCRIBED: 1,
    CONSENT_STATUS_UNSUBSCRIBED: 2,
    CONSENT_STATUS_UNSET: 3,
};
